import { getAccountBadgeValidDistributionStatusChanges, } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PrintIcon from '@mui/icons-material/Print';
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
export const accountBadgeSlideoutStatusIconMap = {
    'not-printed': React.createElement(PrintIcon, { sx: { color: themeColors.accent.grey.bold } }),
    processing: React.createElement(PrintIcon, { sx: { color: themeColors.accent.blue.bold } }),
    printed: React.createElement(PrintIcon, { sx: { color: themeColors.accent.blue.bold } }),
    distributed: React.createElement(HowToRegIcon, { htmlColor: themeColors.accent.green.bold }),
};
export const accountBadgeSlideoutStatusBackgroundColorMap = {
    'not-printed': themeColors.accent.grey.subtlest,
    processing: themeColors.accent.blue.subtlest,
    printed: themeColors.accent.blue.subtlest,
    distributed: themeColors.accent.green.subtlest,
};
export const accountBadgeSlideoutStatusColorMap = {
    'not-printed': themeColors.accent.grey.bold,
    processing: themeColors.accent.blue.bold,
    printed: themeColors.accent.blue.bold,
    distributed: themeColors.accent.green.bold,
};
export const AccountBadgeSlideoutStatus = ({ accountBadge, onDistributionStatusEdit }) => {
    const { t } = useBadgingTranslation();
    const recommendedDistributionStatuses = getAccountBadgeValidDistributionStatusChanges({
        status: accountBadge.columns.status,
        distributionStatus: accountBadge.columns.distributionStatus,
    }).recommended;
    const getRecommendedStatusActionLabel = (distributionStatus) => {
        if (!onDistributionStatusEdit) {
            return '';
        }
        switch (distributionStatus) {
            case 'printed':
                return t('badges.badgeDetails.accountBadgeTable.actions.markAsPrinted');
            case 'distributed':
                return t('badges.badgeDetails.accountBadgeTable.actions.markAsDistributed');
            default:
                return null;
        }
    };
    const getValidStatusDistributionLabel = (accountBadge) => {
        const distributionStatus = accountBadge.columns.distributionStatus;
        const distributionStatusLastUpdatedAt = accountBadge.columns.distributionStatusLastUpdatedAt;
        if (distributionStatus === 'not-printed') {
            return t('badges.badgeDetails.accountBadgeSlideout.statusDescriptionLabels.notPrinted');
        }
        if (distributionStatusLastUpdatedAt && distributionStatus === 'processing') {
            return t('badges.badgeDetails.accountBadgeSlideout.statusDescriptionLabels.processing', {
                date: new Date(distributionStatusLastUpdatedAt).toLocaleDateString(),
            });
        }
        if (distributionStatusLastUpdatedAt && distributionStatus === 'printed') {
            return t('badges.badgeDetails.accountBadgeSlideout.statusDescriptionLabels.printed', {
                date: new Date(distributionStatusLastUpdatedAt).toLocaleDateString(),
            });
        }
        if (distributionStatusLastUpdatedAt && distributionStatus === 'distributed') {
            return t('badges.badgeDetails.accountBadgeSlideout.statusDescriptionLabels.distributed', {
                date: new Date(distributionStatusLastUpdatedAt).toLocaleDateString(),
            });
        }
        return '';
    };
    const status = accountBadge.columns.status;
    if (status === 'valid') {
        return (React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'space-between', sx: {
                padding: 2,
                backgroundColor: accountBadgeSlideoutStatusBackgroundColorMap[accountBadge.columns.distributionStatus],
                borderRadius: 0.5,
            } },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', gap: 1 },
                accountBadgeSlideoutStatusIconMap[accountBadge.columns.distributionStatus],
                React.createElement(Typography, { color: accountBadgeSlideoutStatusColorMap[accountBadge.columns.distributionStatus], variant: 'subtitle2' }, getValidStatusDistributionLabel(accountBadge))),
            React.createElement(Stack, null, recommendedDistributionStatuses.map((distributionStatus) => (React.createElement(Button, { size: 'small', onClick: () => onDistributionStatusEdit === null || onDistributionStatusEdit === void 0 ? void 0 : onDistributionStatusEdit(distributionStatus), key: distributionStatus }, getRecommendedStatusActionLabel(distributionStatus)))))));
    }
    return (React.createElement(Stack, { direction: 'row', alignItems: 'center', gap: 1, sx: { padding: 2, backgroundColor: themeColors.accent.grey.subtlest, borderRadius: 0.5 } },
        React.createElement(InfoOutlinedIcon, { sx: { color: themeColors.accent.grey.bold } }),
        React.createElement(Typography, { variant: 'subtitle2', color: themeColors.accent.grey.bold }, status === 'expired'
            ? t('badges.badgeDetails.accountBadgeSlideout.statusDescriptionLabels.expired')
            : accountBadge.columns.statusReasonDescription)));
};
